import { gql } from 'apollo-angular';

export const notificationListQuery = gql`
  query NotificationList {
    notificationList {
      id
      category
      description
      dateTime
      unread
    }
  }
`;

export const newNotificationSubscription = gql`
  subscription NewNotification {
    newNotification {
      id
      category
      description
      dateTime
      unread
    }
  }
`;

export const markAllAsReadMutation = gql`
  mutation MarkAllAsRead($ids: [ID!]!) {
    markAllAsRead(ids: $ids) {
      id
      category
      description
      dateTime
      unread
    }
  }
`;

export const notificationsSettingsQuery = gql`
  query NotificationsSettings {
    notificationsSettings {
      CRITICAL {
        EMAIL
        INAPP_PUSH
        SMS
      }
      INFORMATION {
        EMAIL
        INAPP_PUSH
        SMS
      }
      SYSTEM {
        EMAIL
        INAPP_PUSH
        SMS
      }
    }
  }
`;

export const notificationsSettingsMutation = gql`
  mutation UpdateNotificationsSettings(
    $eventType: EVENT_CATEGORY!
    $notification: NotificationInput!
  ) {
    updateNotificationsSettings(
      eventType: $eventType
      notification: $notification
    ) {
      CRITICAL {
        EMAIL
        INAPP_PUSH
        SMS
      }
      INFORMATION {
        EMAIL
        INAPP_PUSH
        SMS
      }
      SYSTEM {
        EMAIL
        INAPP_PUSH
        SMS
      }
    }
  }
`;
